import axios from "axios";
import { environment } from "../config.env";

const ENDPOINT_DOMAIN =
  process.env.REACT_APP_ENDPOINT_DOMAIN || environment.endpoint_domain || "";

axios.defaults.baseURL = ENDPOINT_DOMAIN;
// axios.defaults.headers.common['Authorization'] = localStorage.getItem('pg_access_token');

export const registerExecutive = (body) => {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/register/executive`;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};

export const registerAdmin = (body) => {
  return new Promise((resolve) => {
    let url = "/api/v1/admin/register/admin";
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};

export function registerPatient(body) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/register/patient`;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function registerMedical(body) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/register/medicalPersonnel`;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function registerHospitalPersonal(body) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/register/hospitalPersonnel`;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function registerLaboratory(body) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/register/laboratoryAdmin`;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function registerLaboratoryPersonnel(body) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/register/laboratoryPersonnel`;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getUserData(id) {
  return new Promise((resolve) => {
    let url = `api/v1/admin/manage/user/get-user-role-data`;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    let body = {
      uid: id,
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getUserDataList(page, number_per_page, filters, signal, sort, order) {
  return new Promise((resolve) => {
    const path = `/api/v1/admin/manage/user/getUserDataList`;
    let params = {
      page: page,
      number_per_page: number_per_page,
    };

    if (filters.id_card) params.id_card = filters.id_card;
    if (filters.fname) params.fname = filters.fname;
    if (filters.lname) params.lname = filters.lname;
    if (filters.phone_number) params.phone_number = filters.phone_number;
    if (filters.license_number) params.license = filters.license_number;
    if (filters["hospital.hospital_name"])
      params.hospital = filters["hospital.hospital_name"];
    if (filters.laboratory) params.laboratory = filters.laboratory;
    if (filters["auth.role[0]"]) params.role = filters["auth.role[0]"];
    if (filters["auth.enable"] !== "")
      params.enable = filters["auth.enable"];
    if (filters["auth.approve"] !== "")
      params.approve = filters["auth.approve"];
    if (filters.medical_type) params.medical_type = filters.medical_type;
    if (filters["create_date.date"]) params.create_date = filters["create_date.date"];
    if (sort) params.sort = sort;
    if (order) params.order = order;

    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(path, { params, headers: header, signal: signal })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          console.log("Request canceled:", error.message);
          resolve(null);
        } else {
          resolve(false);
        }
      });
  });
}

export function getHistoryLog(
  page,
  number_per_page,
  filters,
  dateFilters,
  sort,
  order,
) {
  return new Promise((resolve) => {
    const path = `/api/v1/admin/manage/user/user-log`;
    let params = {
      page: page,
      number_per_page: number_per_page,
    };

    if (dateFilters) params.access_date = dateFilters;
    if (filters.role_filter) params.role_filter = filters.role_filter;
    if (filters.detail) params.detail = filters.detail;
    if (filters.channel) params.channel = filters.channel;
    if (filters.ip_address) params.ip_address = filters.ip_address;
    if (sort) params.sort = sort;
    if (order) params.order = order;

    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(path, { params, headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}

export function getUserById(id) {
  return new Promise((resolve) => {
    const path = `/api/v1/admin/manage/user/get-user-data`;
    let body = {
      uid: id,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(path, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}

export function ManageUserApprove(uid, approve) {
  return new Promise((resolve) => {
    const path = "/api/v1/admin/manage/user/setApprove";
    let body = {
      uid: uid,
      approve: approve,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(path, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}

export function ManageUserEnable(uid, enable) {
  return new Promise((resolve) => {
    const path = "/api/v1/admin/manage/user/setEnable";
    let body = {
      uid: uid,
      enable: enable,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(path, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}

export function addDocument(formDataBody) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/document/addDocument`;
    let header = {
      "Content-Type": "multipart/form-data",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, formDataBody, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getDocument(
  page,
  numberPerPage,
  name,
  owner,
  created_date,
  updated_date,
  sort,
  order,
) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/document/getDocument`;
    let params = {
      page: page,
      number_per_page: numberPerPage,
    };

    if (name) params.document_name = name;
    if (owner) params.owner = owner;
    if (created_date) params.create_date = created_date;
    if (updated_date) params.update_date = updated_date;
    if (sort) params.sort = sort;
    if (order) params.order = order;

    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(url, { params, headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function removeDocument(documentId) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/document/removeDocument`;
    let body = {
      document_id: documentId,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

//lab guideline
export function addGuideline(
  titleValue,
  title,
  detail,
  pin,
  active,
  publishStartDate,
  publishEndDate,
) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/guideline/addGuideLine`;
    let body = {
      type: titleValue,
      title: title,
      detail: detail,
      active: active,
      pin: pin,
      publish_start_date: publishStartDate,
      publish_end_date: publishEndDate,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function updateGuideline(
  id,
  titleValue,
  title,
  detail,
  pin,
  active,
  publishStartDate,
  publishEndDate,
) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/guideline/updateGuideLine`;
    let body = {
      guideline_id: id,
      type: titleValue,
      title: title,
      detail: detail,
      active: active,
      pin: pin,
      publish_start_date: publishStartDate,
      publish_end_date: publishEndDate,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getGuideline(
  page,
  numberPerPage,
  title,
  created_date,
  update_date,
  sort,
  order,
) {
  return new Promise((resolve) => {

    let url = `/api/v1/admin/guideline/getGuideline`;
    let params = {
      page: page,
      number_per_page: numberPerPage,
    };
 
    if (title) params.title = title;
    if (created_date) params.create_date = created_date;
    if (update_date) params.update_date = update_date;
    if (sort) params.sort = sort;
    if (order) params.order = order;

    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(url, { params, headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function removeGuideline(guidelineId) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/guideline/removeGuideline`;
    let body = {
      guideline_id: guidelineId,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

//announcement ป้ายประชาสัมพันธ์
export function addAnnouncement(title, detail) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/announcement/addAnnouncement`;
    let body = {
      title: title,
      detail: detail,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getAnnouncement(page, numberPerPage) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/announcement/getAnnouncement`;
    let body = {
      page: page,
      number_per_page: numberPerPage,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function removeAnnouncement(announcementId) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/announcement/removeAnnouncement`;
    let body = {
      announcement_id: announcementId,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

//เนื้อหา
export function addContent(
  titleValue,
  imageValue,
  multipleImage,
  category,
  title,
  detailValue,
  fileValue,
  pined,
  active,
  publishStartDate,
  publishEndDate,
  weight,
) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/content/add-content`;
    let body = {
      type: category ?? "",
      thumbnail: imageValue ?? "",
      illustration: multipleImage ?? [],
      file: fileValue ?? "",
      title: title ?? "",
      description: detailValue ?? "",
      publish_start_date: publishStartDate ?? "",
      publish_end_date: publishEndDate ?? "",
      active: active ?? true,
      pined: pined ?? false,
      weight: weight ?? "",
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function updateContent(
  id,
  titleValue,
  imageValue,
  multipleImage,
  category,
  title,
  detailValue,
  fileValue,
  pined,
  active,
  publishStartDate,
  publishEndDate,
  weight,
) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/content/update-content`;
    let body = {
      content_id: id,
      type: category ?? "",
      thumbnail: imageValue ?? "",
      file: fileValue ?? "",
      title: title ?? "",
      description: detailValue ?? "",
      publish_start_date: publishStartDate ?? "",
      publish_end_date: publishEndDate ?? "",
      active: active ?? true,
      pined: pined ?? false,
      weight: weight ?? "",
      illustration: multipleImage ?? [],
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getContent(
  page,
  numberPerPage,
  title,
  type,
  create_date,
  update_date,
  sort,
  order,
) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/content/getContent`;
    let params = {
      page: page,
      number_per_page: numberPerPage,
    };

    if (title) params.title = title;
    if (type) params.type = type;
    if (create_date) params.create_date = create_date;
    if (update_date) params.update_date = update_date;
    if (sort) params.sort = sort;
    if (order) params.order = order;

    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(url, { params, headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function removeContent(id) {
  return new Promise((resolve) => {
    let url = `api/v1/admin/content/remove-content`;
    let body = {
      content_id: id,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function uploadImageContent(image) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/content/upload-image-content`;
    let data = {
      image: image["data"],
    };
    let header = {
      "Content-Type": "multipart/form-data",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, data, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

// export function uploadFileContent(file) {
//   return new Promise((resolve) => {
//     let url = `/api/v1/admin/content/upload-file-content`;
//     let data = {
//       file: file["data"],
//     };
//     let header = {
//       "Content-Type": "multipart/form-data",
//       Authorization: localStorage.getItem("pg_access_token"),
//     };
//     axios
//       .post(url, data, { headers: header })
//       .then((res) => {
//         resolve(res);
//       })
//       .catch(() => {
//         resolve(false);
//       });
//   });
// }

export function uploadFileContent(file) {
  return new Promise((resolve) => {
    const url = `/api/v1/admin/content/upload-file-content`;
    const formData = new FormData();
    formData.append("file", file["data"]);

    const headers = {
      Authorization: localStorage.getItem("pg_access_token"),
    };

    axios
      .post(url, formData, { headers })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

// แบบสอบถาม
export function addQuestionnaire(data) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/questionnaire/addQuestionnaire`;
    let body = {
      active: data.active,
      title: data.title,
      question: data.question,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function editQuestionnaire(id, data) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/questionnaire/updateQuestionnaire`;
    let body = {
      questionnaire_id: id,
      active: data.active,
      title: data.title,
      question: data.question,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getQuestionnaire(
  page,
  numberPerPage,
  id,
  title,
  fname,
  lname,
  active,
  create_date,
  update_date,
  sort,
  order,
) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/questionnaire/getQuestionnaire`;
    let params = {
      page: page,
      number_per_page: numberPerPage,
    };

    if (title) params.title = title;
    if (fname) params.fname = fname;
    if (lname) params.lname = lname;
    if (active) params.active = active;
    if (create_date) params.create_date = create_date;
    if (update_date) params.update_date = update_date;
    if (sort) params.sort = sort;
    if (order) params.order = order;

    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(url, {params, headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getQuestionnaireQuestion(
  page,
  numberPerPage,
  id,
  fname,
  lname,
  create_date,
  sort,
  order
) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/questionnaire/get-questionnaire-question`;
    let params = {
      page: page,
      number_per_page: numberPerPage,
    };

    if (fname) params.fname = fname;
    if (lname) params.lname = lname;
    if (create_date) params.create_date = create_date;
    if (sort) params.sort = sort;
    if (order) params.order = order;

    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(url, { params, headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function removeQuestionnaire(questionnaire_id) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/questionnaire/removeQuestionnaire`;
    let body = {
      questionnaire_id: questionnaire_id,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function removeQuestionnaireQuestion(questionnaire_id) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/questionnaire/removeQuestionnaireQuestion`;
    let body = {
      questionnaire_id: questionnaire_id,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

//อ่านข้อมูลคัดกรองผลแลป
export function getLabClassifyList(page, numberPerPage) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/manage/setting/labclassify/getLabClassifyList`;
    // let body = {
    //   page: page,
    //   number_per_page: numberPerPage,
    // };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(url, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

//เพิ่มข้อมูลคัดกรองผลแลป
export function addLabClassify(lab_data) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/manage/setting/labclassify/addLabClassify`;
    let body = lab_data;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}
//แก้ไขข้อมูลคัดกรองผลแลป
export function updateLabClassify(lab_data) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/manage/setting/labclassify/updateLabClassify`;
    let body = lab_data;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

//แก้ไขข้อมูลคัดกรองผลแลป
export function removeLabClassify(lab_classify_id) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/manage/setting/labclassify/removeLabClassify`;
    let body = {
      lab_classify_id: lab_classify_id,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getHospital(
  page,
  numberPerPage,
  hospital_name,
  create_date,
  update_date,
  sort,
  order,
) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/manage/setting/hospital/webhook/getWebHook`;
    let params = {
      page: page,
      number_per_page: numberPerPage,
    };

    if (hospital_name) params.hospital_name = hospital_name;
    if (create_date) params.create_date = create_date;
    if (update_date) params.update_date = update_date;
    if (sort) params.sort = sort;
    if (order) params.order = order;

    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(url, { headers: header, params })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function saveWebHook(formState) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/manage/setting/hospital/webhook/saveWebHook`;
    let body = formState;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function updateWebHook(id, formState, reset) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/manage/setting/hospital/webhook/saveWebHook`;
    let body = {
      ...formState,
      reset,
    };
    let webhook = { webhook_id: id };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header }, webhook)
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function removeWebHook(webhook_id) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/manage/setting/hospital/webhook/removeWebHook`;
    let body = {
      webhook_id: webhook_id,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function registerHospital(body) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/register/hospital`;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function registerAll(body) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/register/all`;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getPetitionList(page, numberPerPage, filters, create_date, sort, order) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/petition/getPetition`;
    let params = {
      page: page,
      number_per_page: numberPerPage,
    };

    if (filters.status) params.status = filters.status;
    if (filters["petitioner.fname"]) params.owner = filters["petitioner.fname"];
    if (filters["petitioner.lname"]) params.lname = filters["petitioner.lname"];
    if (filters.phone_number) params.phone_number = filters.phone_number;
    if (filters.hospital_name) params.hospital = filters.hospital_name;
    if (create_date) params.create_date = create_date;
    if (sort) params.sort = sort;
    if (order) params.order = order;

    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(url, { params, headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function removePetition(id) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/petition/setPetitionFinish`;
    let body = {
      petition_id: id,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function setPetitionFinish(petition_id) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/petition/setPetitionFinish`;
    let body = {
      petition_id: petition_id,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

//รายชื่อผู้ที่มีผลการตรวจซ้ำ
export function getLabConflict(
  page,
  number_per_page,
  data,
  approve_date,
  receive_date,
  report_date,
  collect_date,
  testing_date,
  sort,
  order,
) {
  return new Promise((resolve) => {
    const path = `/api/v1/admin/conflict/getLabConflict`;
    let params = {
      page: page,
      number_per_page: number_per_page,
    };

    if (data.testing_no) params.document_name = data.testing_no;
    if (data.id_card) params.id_card = data.id_card;
    if (data.hn) params.hn = data.hn;
    if (data["sample_name.prefix"]) params.sample_name_prefix = data["sample_name.prefix"];
    if (data["sample_name.first_name"]) params.sample_name_first_name = data["sample_name.first_name"];
    if (data["sample_name.last_name"]) params.sample_name_last_name = data["sample_name.last_name"];
    if (data.category) params.category = data.category;
    if (data["customer_address.address"]) params.customer_address_address = data["customer_address.address"];
    if (data["customer_address.sub_district_name"]) params.customer_address_sub_district_name = data["customer_address.sub_district_name"];
    if (data["customer_address.district_name"]) params.customer_address_district_name = data["customer_address.district_name"];
    if (data["customer_address.province_name"]) params.customer_address_province_name = data["customer_address.province_name"];
    if (data["customer_address.post_code"]) params.customer_address_post_code = data["customer_address.post_code"];
    if (data.expr2) params.expr2 = data.expr2;
    if (data.testing_result) params.testing_result = data.testing_result;
    if (data.testing_result_type) params.testing_result_type = data.testing_result_type;
    if (data.testing_method) params.testing_method = data.testing_method;
    if (testing_date) params.testing_date = testing_date;
    if (receive_date) params.receive_date = receive_date;
    if (collect_date) params.collect_date = collect_date;
    if (data.customer_name) params.customer_name = data.customer_name;
    if (report_date) params.report_date = report_date;
    if (approve_date) params.approve_date = approve_date;
    if (data.analyst) params.analyst = data.analyst;
    if (data.approver) params.approver = data.approver;
    if (data.report_no) params.report_no = data.report_no;
    if (sort) params.sort = sort;
    if (order) params.order = order;

    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(path, { params, headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        //console.log(error);
      });
  });
}

export function removeLabConflict(lab_id) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/conflict/removeLabConflict`;
    let body = {
      lab_id: lab_id,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

// FAQ
export function addFAQ(titleValue, title, detail, weight) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/faq/add-faq`;
    let body = {
      title: title,
      detail: detail,
      weight: weight,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getFAQ(
  page,
  numberPerPage,
  title,
  detail,
  create_date,
  update_date,
  sort,
  order,
) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/faq/get-faq`;
    let params = {
      page: page,
      number_per_page: numberPerPage,
    };

    if (title) params.title = title;
    if (detail) params.detail = detail;
    if (create_date) params.create_date = create_date;
    if (update_date) params.update_date = update_date;
    if (sort) params.sort = sort;
    if (order) params.order = order;

    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(url, { params, headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function updateFAQ(id, title, detail) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/faq/update-faq`;
    let body = {
      faq_id: id,
      title: title,
      detail: detail,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function removeFAQ(id) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/faq/remove-faq `;
    let body = {
      faq_id: id,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

// Contact
export function addContact(data) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/contact/add-contact`;
    let body = data;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getContact(
  page,
  numberPerPage,
  owner,
  department,
  phone,
  create_date,
  update_date,
  sort,
  order,
) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/contact/get-contact`;
    let params = {
      page: page,
      number_per_page: numberPerPage,
    };

    if (owner) params.owner = owner;
    if (department) params.department = department;
    if (phone) params.phone = phone;
    if (create_date) params.create_date = create_date;
    if (update_date) params.update_date = update_date;
    if (sort) params.sort = sort;
    if (order) params.order = order;

    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(url, { params, headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function updateContact(id, data) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/contact/update-contact`;
    let body = {
      contact_id: id,
      prefix: data[0].prefix,
      firstName: data[0].firstName,
      lastName: data[0].lastName,
      phone: data[0].phone,
      email: data[0].email,
      department: data[0].department,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function removeContact(id) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/contact/remove-contact `;
    let body = {
      contact_id: id,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

//Menu
export function addMenu(data) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/menu/addMenu`;
    let body = data;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}
export function addMenuFlag(data) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/menu/updateMenuFlag`;
    let body = data;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}
export function getMenu(data) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/menu/getMenu`;
    let body = {
      data: data ?? "get data",
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getMenuList(
  page,
  number_per_page,
  role,
  name,
  create_date,
  update_date,
  sort,
  order,
) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/menu/getMenuList`;
    let params = {
      page: page,
      number_per_page: number_per_page,
    };

    if (role) params.role = role;
    if (name) params.name = name;
    if (create_date) params.create_date = create_date;
    if (update_date) params.update_date = update_date;
    if (sort) params.sort = sort;
    if (order) params.order = order;

    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(url, { params, headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}
export function updateMenu(id, data) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/menu/updateMenu`;
    let body = {
      menu_id: id,
      role: data.role,
      name: data.name,
      weight: data.weight,
      parent_id: data.parent_id,
      url: data.url,
      external: data.external,
      active: data.active,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}
export function removeMenu(id) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/menu/removeMenu`;
    let body = {
      menu_id: id,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function UpdateRegisterAll(body) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/register/update-register-all`;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function CheckUserAuthority(data) {
  return new Promise((resolve) => {
    let url = `api/v1/admin/manage/user/check-user-authority `;
    let body = data;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function SetEnableUser(data) {
  return new Promise((resolve) => {
    let url = `api/v1/admin/manage/user/setEnable`;
    let body = data;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function UpdateUserRole(role, data, permissionEmail) {
  return new Promise((resolve) => {
    try {
      let url = `api/v1/admin/manage/user/update-user-role`;
      let body = {
        roles: role ?? [],
        pname: data.prefix ?? "",
        fname: data.firstName ?? "",
        lname: data.lastName ?? "",
        pid: data.id_card ?? "",
        gender: data.gender ?? "",
        birthday: data.birthday ?? "",
        current_address: {
          address: data.address ?? "",
          village_number: data.village_number ?? "",
          building: data.building ?? "",
          sub_district_id: data.sub_district_id ?? "",
          district_id: data.district_id ?? "",
          province_id: data.province_id ?? "",
          health_area: data.health_area ?? "",
          post_code: data.post_code ?? "",
        },
        phone_number: data.phone_number ?? "",
        email: data.email ?? "",
        username: data.username ?? "",
        password: data.password ?? "",
        confirm_password: data.confirm_password ?? "",
        hospital_id: data.hospital_id ?? "",
        licenses: data.licenses ?? "",
        laboratories: {
          LABORATORY_ADMIN: {
            id: data.laboratory_id ?? "",
            name: data.laboratory_name ?? "",
            address: data.laboratory_address ?? "",
            village_number: data.laboratory_moo ?? "",
            alley: data.laboratory_soy ?? "",
            road: data.laboratory_road ?? "",
            post_code: data.laboratory_postCode ?? "",
            latitude: data.latitude ?? "",
            longitude: data.longitude ?? "",
          },
          LABORATORY_PERSONNEL: {
            id: data.laboratory_id ?? "",
          },
        },
        petitions: {
          LABORATORY_ADMIN: {
            staff_role: [
              data.LABORATORY_ADMIN?.analyst && "ANALYST",
              data.LABORATORY_ADMIN?.approver && "APPROVER",
            ].filter(Boolean),
            attach_file: data.LABORATORY_ADMIN?.attach_file ?? {},
            position: data.LABORATORY_ADMIN?.position ?? "",
          },
          LABORATORY_PERSONNEL: {
            staff_role: [
              data.LABORATORY_PERSONNEL?.analyst && "ANALYST",
              data.LABORATORY_PERSONNEL?.approver && "APPROVER",
            ].filter(Boolean),
            attach_file: data.LABORATORY_PERSONNEL?.attach_file,
            position: data.LABORATORY_PERSONNEL?.position,
          },
        },
        permission: {
          access_to_email: permissionEmail,
        },
      };
      let header = {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("pg_access_token"),
      };
      axios
        .post(url, body, { headers: header })
        .then((res) => {
          resolve(res);
        })
        .catch(() => {
          resolve(false);
        });
    } catch (error) {
      console.error("Error occurred: ", error);
    }
  });
}

/**
 * banner
 */
export function getBanner(
  page,
  numberPerPage,
  weight,
  active,
  create_date,
  update_date,
  sort,
  order,
) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/banner/getBanner`;
    let params = {
      page: page,
      number_per_page: numberPerPage,
    };

    if (weight) params.weight = weight;
    if (active !== "") params.active = active;
    if (create_date) params.create_date = create_date;
    if (update_date) params.update_date = update_date;
    if (sort) params.sort = sort;
    if (order) params.order = order;

    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(url, { params, headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function addBanner(image, weight, active) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/banner/addBanner`;
    let body = {
      url: image,
      weight: weight,
      active: active,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function updateBanner(id, image, weight, active) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/banner/updateBanner`;
    let body = {
      banner_id: id,
      url: image,
      weight: weight,
      active: active,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function removeBanner(id) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/banner/deleteBanner`;
    let body = {
      banner_id: id,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

/**
 * pharmacogenetics
 */
export function getPharmacogeneticsList(
  page,
  numberPerPage,
  name,
  weight,
  active,
  create_date,
  update_date,
  sort,
  order
) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/pharmacogenetics/list`;
    let params = {
      page: page,
      number_per_page: numberPerPage,
    };

    if (name) params.name = name;
    if (weight) params.weight = weight;
    if (active) params.active = active;
    if (create_date) params.create_date = create_date;
    if (update_date) params.update_date = update_date;
    if (sort) params.sort = sort;
    if (order) params.order = order;

    let header = {
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .get(url, { params, headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function addPharmacogenetics(image, weight, active, name) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/pharmacogenetics/add-pharmacogenetics`;
    let body = {
      name: name,
      url: image,
      weight: weight,
      active: active,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function updatePharmacogenetics(id, image, weight, active, name) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/pharmacogenetics/update-pharmacogenetics`;
    let body = {
      form_id: id,
      name: name,
      url: image,
      weight: weight,
      active: active,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function removePharmacogenetics(id) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/pharmacogenetics/remove-pharmacogenetics`;
    let body = {
      form_id: id,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function uploadFilePharmacogenetics(file) {
  return new Promise((resolve) => {
    let url = `/api/v1/admin/pharmacogenetics/upload-file-pharmacogenetics`;
    let data = {
      file: file["data"],
    };
    let header = {
      "Content-Type": "multipart/form-data",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, data, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}
